"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEventDate = setEventDate;
exports.resetEventDate = resetEventDate;
exports.setEventDuration = setEventDuration;
exports.setGivenConsent = setGivenConsent;
exports.resetConsentResponses = resetConsentResponses;
exports.setTimezone = setTimezone;
exports.setFormValue = setFormValue;
exports.resetFormState = resetFormState;
exports.setFormState = exports.submitConsentResponses = exports.resetEventDateTime = exports.setEventDateTime = void 0;

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _AutoSubmitSelector = require("MeetingsLib/selectors/AutoSubmitSelector");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _BookActions = require("./BookActions");

function setEventDate(dateString) {
  return {
    type: ActionTypes.SET_EVENT_DATE,
    date: dateString
  };
}

function resetEventDate() {
  return {
    type: ActionTypes.SET_EVENT_DATE,
    date: null
  };
}

var setEventDateTime = function setEventDateTime(millisDateTime) {
  return function (dispatch, getState) {
    dispatch({
      type: ActionTypes.SET_EVENT_DATE_TIME,
      dateTime: millisDateTime
    });

    if ((0, _AutoSubmitSelector.canSubmitBooking)(getState())) {
      dispatch((0, _BookActions.bookMeeting)());
    }
  };
};

exports.setEventDateTime = setEventDateTime;

var resetEventDateTime = function resetEventDateTime() {
  return {
    type: ActionTypes.SET_EVENT_DATE_TIME,
    dateTime: null
  };
};

exports.resetEventDateTime = resetEventDateTime;

function setEventDuration(duration) {
  return {
    type: ActionTypes.SET_EVENT_DURATION,
    duration: duration
  };
}

function setGivenConsent(checkbox, checked) {
  return {
    type: ActionTypes.SET_GIVEN_CONSENT,
    communicationTypeId: checkbox.communicationTypeId,
    consented: checked
  };
}

var submitConsentResponses = function submitConsentResponses(stagedLegalConsentResponses) {
  return function (dispatch, getState) {
    dispatch({
      type: ActionTypes.SET_CONSENT_RESPONSES,
      payload: stagedLegalConsentResponses
    });

    if ((0, _BookInfoSelectors.getIsLegitimateInterest)(getState())) {
      dispatch({
        type: ActionTypes.SET_LEGITIMATE_INTEREST_CONFIRMED
      });
    }

    if ((0, _AutoSubmitSelector.canSubmitBooking)(getState())) {
      dispatch((0, _BookActions.bookMeeting)());
    }
  };
};

exports.submitConsentResponses = submitConsentResponses;

function resetConsentResponses() {
  return {
    type: ActionTypes.RESET_CONSENT_RESPONSES
  };
}

function setTimezone(timezone) {
  return {
    type: ActionTypes.SET_TIMEZONE,
    timezone: timezone
  };
}

function setFormValue(formFieldName, formFieldValue) {
  return {
    type: ActionTypes.SET_FORM_FIELD,
    payload: {
      fieldName: formFieldName,
      fieldValue: formFieldValue
    }
  };
}

function resetFormState() {
  return {
    type: ActionTypes.RESET_FORM_STATE
  };
}

var setFormState = function setFormState(stagedFormState) {
  return function (dispatch, getState) {
    dispatch({
      type: ActionTypes.SET_FORM_STATE,
      payload: stagedFormState
    });

    if ((0, _AutoSubmitSelector.canSubmitBooking)(getState())) {
      dispatch((0, _BookActions.bookMeeting)());
    }
  };
};

exports.setFormState = setFormState;